module.exports = __webpack_public_path__ + "static/media/jetSki-orange.fca880a7.png";